/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Sidebar, Text, theme, Button } from "@nordcloud/gnui";
import { ERROR_TEXT } from "~/constants";
import { showError } from "~/services/toast";
import { optionsNames, options } from "./CostSplittingDefs";
import { Footer, Option, OptionInner } from "./styles";
import { CostMappingAlgorithm } from "./types";

type Props = {
  isOpen: boolean;
  originRowId: string;
  onSelect: (id: string, algorithm: CostMappingAlgorithm) => void;
  onClose: () => void;
};

export function CostSplittingAlgorithmSelector({
  isOpen,
  onSelect,
  originRowId,
  onClose,
}: Props) {
  const [algorithm, setAlgorithm] = React.useState<
    CostMappingAlgorithm | undefined
  >();

  const onNext = () => {
    try {
      if (algorithm) {
        onSelect(originRowId, algorithm);
        setAlgorithm(undefined);
      }
    } catch {
      showError(ERROR_TEXT.default);
    }
  };

  return (
    <Sidebar
      isOpen={isOpen}
      title="Cost splitting algorithm"
      footer={
        <Footer>
          <Button disabled={!algorithm} onClick={onNext}>
            Next
          </Button>
        </Footer>
      }
      onClick={onClose}
    >
      {optionsNames.map((optionName) => {
        const option = options.get(optionName);
        const Icon = option?.icon;

        return (
          <Option
            key={option?.label}
            withHover
            selected={optionName === algorithm}
            onClick={() => setAlgorithm(optionName)}
          >
            <div>{Icon}</div>
            <OptionInner>
              <Text size="md" weight="medium">
                {option?.label}
              </Text>
              <Text
                tag="div"
                size="sm"
                color={theme.color.text.text02}
                weight="regular"
              >
                {option?.desc}
              </Text>
            </OptionInner>
          </Option>
        );
      })}
    </Sidebar>
  );
}
